import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import {
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Accordion,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { DatePickerCustomButton, TitledCard } from 'Components';
import { DatePickerField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { OPEN_ORDERS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { OpenOrderReportEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import SelectSitesTable from 'Common/SelectSitesTable';
import { groupByOptions } from './../helper/index';

const OpenOrdersReportComponent = props => {
  const {
    onChangeOfFromDT,
    fromDateMax,
    fromDateMin,
    onChangeOfToDT,
    toDateMin,
    setGroupByOption,
    groupByOptionsValue,
    clearFilters,
    setSelectedSites,
    getSitesCallback,
    activeIndexForFilter,
    handleClick,
    reactTableRef,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column width={8}>
                  <div style={{ paddingTop: 25 }}>
                    <Header as="h4">Delivery Date Range</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    label={'FROM:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={OpenOrderReportEnum.FromDT}
                    onChange={onChangeOfFromDT}
                    maxDate={fromDateMax}
                    minDate={fromDateMin}
                    type={'text'}
                    dropdownMode="select"
                    customInput={<DatePickerCustomButton />}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    label={'TO:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={OpenOrderReportEnum.EndDT}
                    type={'text'}
                    onChange={onChangeOfToDT}
                    minDate={toDateMin}
                    customInput={<DatePickerCustomButton />}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={13}>
                  <TitledCard title={'Group By'}>
                    <ReduxFormButtonGroup
                      options={groupByOptions}
                      value={groupByOptionsValue}
                      formName={OPEN_ORDERS_REPORT_FORM_NAME}
                      fieldName={OpenOrderReportEnum.GroupByOptions}
                      onChange={setGroupByOption}
                      type={'button'}
                    />
                  </TitledCard>
                </Grid.Column>
                <Grid.Column
                  width={3}
                  textAlign={'right'}
                  style={{ marginTop: '45px' }}
                  floated={'right'}
                >
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <TitledCard>
          <SelectSitesTable
            onChange={setSelectedSites}
            getSitesCallback={getSitesCallback}
            isActive={true}
            isLicensed={false}
            showPageSizeOptions={true}
            defaultPageSize={20}
            filterable={true}
            sortable={true}
            tableProps={{ ref: reactTableRef }}
          />
        </TitledCard>
      </Form>
    </Fragment>
  );
};

OpenOrdersReportComponent.propTypes = {
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  setGroupByOption: PropTypes.func,
  clearFilters: PropTypes.func,
  setSelectedSites: PropTypes.func,
  getSitesCallback: PropTypes.func,
  handleClick: PropTypes.func,
  fromDateMax: PropTypes.object,
  fromDateMin: PropTypes.object,
  toDateMin: PropTypes.object,
  reactTableRef: PropTypes.object,
  groupByOptionsValue: PropTypes.number,
  activeIndexForFilter: PropTypes.number,
};

OpenOrdersReportComponent.defaultProps = {
  onChangeOfFromDT: () => {},
  onChangeOfToDT: () => {},
  setGroupByOption: () => {},
  clearFilters: () => {},
  setSelectedSites: () => {},
  getSitesCallback: () => {},
  fromDateMax: null,
  fromDateMin: null,
  toDateMin: null,
  reactTableRef: null,
  groupByOptionsValue: 0,
  activeIndexForFilter: 0,
};

export default OpenOrdersReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/openordersreport/components/OpenOrdersReport.js